import type { ReactNode } from "react";
import Title from "../UI/Title";
import Text from "../UI/Text";
import styles from "./AuthHeader.module.css";

interface AuthHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
}

export default function AuthHeader({ title, subtitle }: AuthHeaderProps) {
  return (
    <div className={styles.header}>
      <Title variant="mega">{title}</Title>
      {subtitle && <Text variant="deci">{subtitle}</Text>}
    </div>
  );
}
